<template>
  <div
    class="pricing-cards"
    :style="{ '--pricing-cards-count': currentPlans.length }"
  >
    <pricing-card
      v-for="plan in currentPlans"
      :key="plan.id"
      :plan-id="plan.id"
      :plan-name="plan.name"
      :plan-price="
        plan.id === 'district' ? 'Custom Pricing' : currentPrices[plan.id].price
      "
      :plan-description="plan.description"
      :discount-percent="plan.discount"
      :features-heading="plan.featuresHeading"
      :features="plan.features"
      :yearly-toggle="yearlyToggle"
      :button="plan.button"
      :width="cardWidth"
      :is-subscribed="plan.id === userPlan && isCurrentPlanOnSameInterval"
      @select-plan="selectPlan"
    />
  </div>
</template>

<script>
import PricingCard from "./pricing_card.vue";
import { PRICING_PLANS } from "@/constants";
import upgradePlanMixin from "@/mixins/upgradePlan";

export default {
  name: "PricingCardExample",

  components: {
    PricingCard,
  },

  /*
    this.upgradeWithConfirmation
    */
  mixins: [upgradePlanMixin],

  props: {
    yearlyToggle: {
      type: Boolean,
      default: true,
    },
    cardWidth: {
      type: String,
      default: "260px",
    },

    currentPlan: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    pricingPlans() {
      return PRICING_PLANS;
    },
    userPlan() {
      return this.user?.plan?.toLowerCase() || "basic";
    },
    currentPlans() {
      return (this.pricingPlans.teachers || []).map((plan) => ({
        ...plan,
        description: this.$t(`${plan.translationKey}.description`),
        button: {
          ...plan.button,
          text: this.$t(`${plan.translationKey}.button`),
        },
        featuresHeading: plan.featuresHeading
          ? this.$t(`${plan.translationKey}.featuresHeading`)
          : null,
        features: this.getPlanFeatures(plan),
      }));
    },
    currentPrices() {
      const plans = this.currentPlans;
      const result = {};

      plans.forEach((plan) => {
        let price = this.yearlyToggle
          ? plan.yearlyPrice / 12
          : plan.monthlyPrice;

        let yearly = this.yearlyToggle
          ? plan.yearlyPrice
          : plan.monthlyPrice * 12;

        price = price.toFixed(2);
        yearly = yearly.toFixed(2);

        result[plan.id] = {
          price,
          yearly,
        };
      });

      return result;
    },
    isCurrentPlanOnSameInterval() {
      if (!this.currentPlan) {
        return false;
      }

      return (
        this.currentPlan?.interval === (this.yearlyToggle ? "year" : "month")
      );
    },
  },

  methods: {
    getPlanFeatures(plan) {
      const locale = this.$i18n.locale;
      const messages = this.$i18n.getLocaleMessage(locale);
      const parts = `${plan.translationKey}.features`.split(".");
      const translated = parts.reduce((obj, key) => obj?.[key], messages);
      return Array.isArray(translated) ? translated : plan.features;
    },

    async selectPlan({ planId, resolve }) {
      if (planId === "district") {
        window.location.href = "https://forms.gle/2JUKUyBYerutzCi36";

        return;
      }

      try {
        const nextPlan = this.currentPlans.find((p) => p.id === planId);
        const result = await this.upgradeWithConfirmation({
          nextPlan,
          yearlyToggle: this.yearlyToggle,
        });

        if (result) {
          this.$emit("select-plan", planId);
        }
      } catch (error) {
        console.error(error);
      } finally {
        resolve && resolve();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.pricing-cards {
  display: flex;
  gap: 16px;
  justify-content: center;
  max-width: 1344px;
  margin: 0 auto;
}
</style>
